import { useEffect, useCallback, useState } from 'react';
import { useFetchAssetRecommendation, extractCacheRelatedId } from '@bingads-webui-campaign-react/pmax-landing-utils';

export function useInitializeCache() {
  const { cacheId, email, signature } = extractCacheRelatedId();

  const [cacheInitialized, setCacheInitialized] = useState(!cacheId);
  const [isFetching, setIsFetching] = useState(false);
  const [cache, setCache] = useState();
  const [entityErr, setEntityErr] = useState();
  const { lookupAssetRecommendation } = useFetchAssetRecommendation();

  const onEntityReadError = useCallback((error) => {
    setEntityErr(error);
  }, []);

  useEffect(() => {
    if (!cacheInitialized && !isFetching && !entityErr) {
      setIsFetching(true);
      lookupAssetRecommendation(cacheId, email, signature).then((res) => {
        if (res.website && res.recommendations) {
          setCache(res);
        }
      }).catch(onEntityReadError).finally(() => {
        setCacheInitialized(true);
        setIsFetching(false);
      });
    }
  }, [cacheId, cacheInitialized, email, entityErr, isFetching,
    lookupAssetRecommendation, onEntityReadError, signature]);

  return {
    cache,
    cacheInitialized,
  };
}
